import { Col, Row, Table } from 'antd';
import { billListSelectors } from 'containers/App/selectors';
import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from 'components';
import { t_billing_process } from 'types';
import { getDataCPAPFromHospital } from '../../ListBilling/thunk';

type Props = {
  bill: t_billing_process;
  loadData: boolean;
  setLoadData: any;
};

const TableCpap: FC<Props> = ({ bill, loadData, setLoadData }) => {
  const dispatch = useDispatch();
  const { detailCPAPFromHosital } = useSelector(billListSelectors);
  const [page, setPage] = useState<number>(1);

  const handleChangePage = async (page: number) => {
    setPage(page);
    setLoadData(true);
  };

  useEffect(() => {
    (async () => {
      if (loadData) {
        const result: any = await dispatch(
          getDataCPAPFromHospital({
            invoice_id: bill.i_id || '',
            billing_type: ['o_normal', 'o_unpaid_collection', 'o_normal_past_no_claim'],
            page: page,
            per_page: 50,
          }),
        );
        if (result.payload) {
          setLoadData(false);
        }
      }
    })();
    if (!detailCPAPFromHosital) {
      setPage(1);
    }
  }, [dispatch, bill, loadData, setLoadData, page]);

  const columns: any = useMemo(() => {
    return [
      {
        title: 'No.',
        dataIndex: 'no',
        key: 'no',
        width: '5%',
        align: 'center',
        render(text: string, row: any, index: any) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{index + 1}</div>,
          };
        },
      },
      {
        title: 'ID',
        dataIndex: 'patient_id',
        key: 'patient_id',
        width: '10%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: 'ご利用者名',
        dataIndex: 'cpap_id',
        key: 'cpap_id',
        width: '15%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: 'CPAP請求月',
        key: 'target_month',
        dataIndex: 'target_month',
        width: '15%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text ? `${text.slice(0, 4)}年${Number(text.slice(4))}月` : ''}</div>,
          };
        },
      },
      {
        title: '備考',
        key: 'hospital_visit_remark',
        dataIndex: 'hospital_visit_remark',
        width: '40%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', paddingLeft: '10px' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];
  }, []);

  return (
    <div>
      <Table
        columns={columns}
        dataSource={detailCPAPFromHosital ? detailCPAPFromHosital.items : []}
        pagination={false}
      />
      <Row style={{ marginTop: '21px' }}>
        <Col span={24}>
          <Pagination
            page={page}
            totalItems={detailCPAPFromHosital ? detailCPAPFromHosital.totalItems : 0}
            onChangePage={handleChangePage}
            per_page={50}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TableCpap;
